import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function Success() {
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Jost', sans-serif",
      backgroundColor: '#faf8f5',
      padding: '40px 20px',
    }}>

      {/* Checkmark icon */}
      <div style={{
        width: '72px',
        height: '72px',
        borderRadius: '50%',
        border: '1.5px solid #9b8575',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '32px',
        color: '#9b8575',
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>

      {/* Title */}
      <h1 style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '2.4rem',
        fontWeight: 400,
        color: '#3a2218',
        margin: '0 0 12px 0',
        letterSpacing: '0.02em',
        textAlign: 'center',
      }}>
        წარმატებული გადახდა
      </h1>

      {/* Subtitle */}
      <p style={{
        fontSize: '0.72rem',
        fontWeight: 300,
        letterSpacing: '0.15em',
        color: '#9b8575',
        textTransform: 'uppercase',
        margin: '0 0 48px 0',
        textAlign: 'center',
      }}>
        თქვენი შეკვეთა მიღებულია
      </p>

      {/* Divider */}
      <div style={{
        width: '48px',
        height: '1px',
        backgroundColor: '#e0d8cf',
        marginBottom: '48px',
      }} />

      {/* Back button */}
      <button
        onClick={() => navigate('/')}
        style={{
          background: 'none',
          border: '1px solid #3a2218',
          color: '#3a2218',
          fontFamily: "'Jost', sans-serif",
          fontSize: '0.68rem',
          letterSpacing: '0.25em',
          textTransform: 'uppercase',
          fontWeight: 300,
          padding: '14px 36px',
          cursor: 'pointer',
          transition: 'all 0.25s ease',
        }}
        onMouseEnter={e => {
          e.target.style.background = '#3a2218'
          e.target.style.color = '#f7f4ef'
        }}
        onMouseLeave={e => {
          e.target.style.background = 'none'
          e.target.style.color = '#3a2218'
        }}
      >
        მთავარ გვერდზე დაბრუნება
      </button>

    </div>
  )
}

export default Success